import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { PRICING_DATA } from '../constants/pricing';

/**
 * Shared hook — used by PricingPage, SubscriptionPage, anywhere pricing is shown.
 * Fetches live from Supabase. Falls back to hardcoded constants on error.
 */
export function usePricingPlans() {
  const [plans, setPlans] = useState([]);
  const [accelerators, setAccelerators] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchPricing() {
      setLoading(true);
      try {
        const { data: plansData, error: plansErr } = await supabase
          .from('pricing_plans')
          .select('*, plan_features(text, included, sort_order)')
          .eq('is_active', true)
          .order('sort_order');

        const { data: accData, error: accErr } = await supabase
          .from('accelerator_packages')
          .select('*')
          .eq('is_active', true);

        if (cancelled) return;

        if (!plansErr && plansData && plansData.length > 0) {
          const sorted = plansData.map(p => ({
            ...p,
            features: [...(p.plan_features || [])].sort(
              (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)
            ),
          }));
          setPlans(sorted);
        } else {
          setPlans(PRICING_DATA.monthly_plans);
        }

        if (!accErr && accData && accData.length > 0) {
          setAccelerators(accData);
        } else {
          setAccelerators(PRICING_DATA.accelerator_packages);
        }
      } catch {
        if (!cancelled) {
          setPlans(PRICING_DATA.monthly_plans);
          setAccelerators(PRICING_DATA.accelerator_packages);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchPricing();
    return () => { cancelled = true; };
  }, []);

  return { plans, accelerators, loading };
}
